import { render } from "./MainNav.vue?vue&type=template&id=1689c5f8"
import script from "./MainNav.vue?vue&type=script&lang=js"
export * from "./MainNav.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/staff/staff/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__